type TObject = { [key: string]: any };

function copyParams<T = TObject>(source: T, target: TObject): T {
  return Object.assign(source, Object.fromEntries(Object.entries(target)));
}

export default copyParams;
